// ---------------------------------------------------------------------------
// Turns off zod's "JIT" parser. MUST be the first import in src/index.js.
//
// The API reference page (Scalar) validates its configuration with zod 4. When the first object schema is built
// (the result is cached, so once per page load), zod probes whether the page may compile code at runtime (`new Function("")`) to decide if it can
// use a faster, generated parser. This site's Content-Security-Policy (template.yml) forbids that (no
// 'unsafe-eval'), so the probe throws and zod falls back to its ordinary parser, but the browser still
// REPORTS the blocked attempt: a `script-src blocked eval` violation and a red console error on every load.
//
// `jitless` makes zod skip the probe entirely, so nothing is attempted and nothing is reported. The only
// effect is speed: object parsing uses the ordinary path instead of the generated one (not measured here).
// The policy is NOT loosened.
//
// Why it must come first: the probe runs when Scalar's modules build their schemas, i.e. when they are
// evaluated, so the setting has to be in place before anything that imports Scalar (App -> DocsPage).
// ES imports are hoisted and evaluated in order, so this has to be the first import line, not a statement.
// ---------------------------------------------------------------------------

import { config } from 'zod';

config({ jitless: true });
